/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportCaseCreatedDto } from '../../models/financial-support-case-created-dto';
import { FinancialSupportCaseCreateDto } from '../../models/financial-support-case-create-dto';

export interface FinancialSupportCaseControllerCreate$Params {
      body: FinancialSupportCaseCreateDto
}

export function financialSupportCaseControllerCreate(http: HttpClient, rootUrl: string, params: FinancialSupportCaseControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseCreatedDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportCaseControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportCaseCreatedDto>;
    })
  );
}

financialSupportCaseControllerCreate.PATH = '/api/financial-support/cases';
